import type { ColDef, ICellRendererParams, IRowNode } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import type { TypeExchangeDetailData } from '~/types/claim.types';

type TypeExchangeDeliveryInfo = TypeExchangeDetailData['exchangeOrder']['exchangeOrderItems'][number];

/**
 * [교환 신청/조회] 신청 상세 모달 > '교환 배송 정보' 테이블 컬럼 정의
 */
const getClaimExchangeDetailDeliveryColumnDefs = ({
  onClickOutboundOrderCode,
}: {
  onClickOutboundOrderCode: (outboundOrderCode: string) => void;
}) => {
  const columnDefs: ColDef<TypeExchangeDeliveryInfo>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'outboundOrderCode',
      headerName: '출고요청번호',
      width: 180,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({
        data,
      }: ICellRendererParams<TypeExchangeDeliveryInfo, TypeExchangeDeliveryInfo['outboundOrderCode']>) => ({
        children: data?.outboundOrderCode,
        onClick: ({ data }: IRowNode<TypeExchangeDeliveryInfo>) => {
          if (!data?.outboundOrderCode) return;
          onClickOutboundOrderCode(data.outboundOrderCode);
        },
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 130,
    },
    {
      field: 'goodsName',
      headerName: '상품명',
      minWidth: 438,
      flex: 1,
    },
    {
      field: 'quantity',
      headerName: '배송수량',
      width: 76,
      cellStyle: { textAlign: 'right' },
    },
  ];

  return { columnDefs };
};

export default getClaimExchangeDetailDeliveryColumnDefs;
